export default "__VITE_ASSET__CcQqHBJ2__"